import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'lib-tooltip',
  imports: [
    NgClass
  ],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.css'
})
export class TooltipComponent {
  @Input() text = '';
  @Input() tooltipClass: string | string[] | Set<string> | { [klass: string]: any } = [];
}
